/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFieldSets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Field Sets
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 02:58:19 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FIELDSET_LIST_CONTAINER_LOADED,
    FIELDSET_LIST_CONTAINER_UNLOADED,
    FIELDSET_LIST_TABLE_LOADED,
    FIELDSET_LIST_TABLE_UNLOADED,

    FIELDSET_SELECT_ROW,
    FIELDSET_ADD,
    FIELDSET_EDIT,
    FIELDSET_DELETE,
    FIELDSET_OPEN_WARNING,
    FIELDSET_CLOSE_WARNING,
    FIELDSET_DELETE_DISABLE,

    FIELDSET_EDIT_CONTAINER_LOADED,
    FIELDSET_EDIT_CONTAINER_UNLOADED,
    FIELDSET_EDIT_FORM_LOADED,
    FIELDSET_EDIT_FORM_UNLOADED,
    FIELDSET_SET_PATHTRAIL,
    FIELDSET_EDIT_DATA_LOAD,
    FIELDSET_EDIT_CONTAINER_SUBMIT,
    FIELDSET_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeFieldSets';

const defaultState = {
    refreshList: false,
    danger: false,
    fieldsetid: 0,
    fieldsetgroupid: 0,
    name: '',
    description: '',
    mastersql: '',
    mainjoin: '',
    mastercriteria: '',
    createdate: '',
    modifydate: '',
    pathTrail: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FIELDSET_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                fieldsets: action.payload[0] ? action.payload[0].records : null,
                fieldsetgroups: action.payload[1] ? action.payload[1].records : null
            }
        case FIELDSET_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FIELDSET_SELECT_ROW:
            return {
                ...state,
                fieldsetid: action.id
            }
        case FIELDSET_ADD:
            return {
                ...state
            }
        case FIELDSET_EDIT:
            return {
                ...state,
                fieldsetid: action.id
            }
        case FIELDSET_DELETE:
            return {
                ...state,
                fieldsetid: null
            }
        case FIELDSET_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case FIELDSET_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FIELDSET_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case FIELDSET_EDIT_CONTAINER_LOADED:
        case FIELDSET_EDIT_DATA_LOAD:
            return {
                ...state,
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : 0,
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : 0,
                fieldsetgroup: action.payload[0] ? action.payload[0].fieldsetgroup : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                mastersql: action.payload[0] ? action.payload[0].mastersql : '',
                mainjoin: action.payload[0] ? action.payload[0].mainjoin : '',
                mastercriteria: action.payload[0] ? action.payload[0].mastercriteria : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                fieldsetpath: action.payload[1] ? action.payload[1].records : '',
            }
        case FIELDSET_SET_PATHTRAIL:
            return {
                ...state,
                pathTrail: action.pathTrail ? action.pathTrail : ''
            }
        case FIELDSET_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FIELDSET_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FIELDSET_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FIELDSET_LIST_CONTAINER_UNLOADED:
        case FIELDSET_LIST_TABLE_UNLOADED:
        case FIELDSET_EDIT_CONTAINER_UNLOADED:
        case FIELDSET_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFieldSets.js